const Enums = {
      "insertFunctions": {
        "lt": {
          "UZSIENIO_FIZ_INSERT":"Senoji funkcija (UZSIENIO_FIZ_INSERT)",
          "UZSIENIO_FIZ_INSERT_IREG":"Naujoji funkcija (UZSIENIO_FIZ_INSERT_IREG)",
        },
        "en": {
          "UZSIENIO_FIZ_INSERT":"Senoji funkcija (UZSIENIO_FIZ_INSERT)",
          "UZSIENIO_FIZ_INSERT_IREG":"Naujoji funkcija (UZSIENIO_FIZ_INSERT_IREG)",
        }
    },

     "application": {
        "lt": {
           "self-service":"Savitarna",
           "ireg":"ĮREG",
           "public-search":"Vieša paieška",
        },
        "en": {
           "self-service":"Self-service",
           "ireg":"ĮREG",
           "public-search":"Public search",
        }
     },

     "errorMessagesTypes": {
        "lt": {
           "success": "Sėkmės",
           "info": "Informacinis",
           "warning": "Įspėjimas",
           "error": "Klaida"
        },
        "en": {
           "success": "Success",
           "info": "Info",
           "warning": "Warning",
           "error": "Error"
        }
     },

    "sector": {
      "lt": {
        "jur-public": "Viešojo juridinio asmens teikiama paslauga",
        "jur-private": "Privataus juridinio asmens teikiama paslauga",
        "jur-private-public": "Viešojo arba privataus juridinio asmens teikiama paslauga",
        "fiz": "Fizinio asmens teikiama paslauga",
        "fiz-jur": "Fizinio ar juridinio asmens teikiama paslauga"
      },
      "en": {
        "jur-public": "Only public legal entity",
        "only-private-legal-entity": "Only private legal entity",
        "jur-private-public": "Public and private legal entity",
        "fiz": "Service provided by a natural person",
        "fiz-jur": "Service provided by a natural person or a legal entity."
      }
    },

    "whoMayConsituteMandateType": {
      "lt": {
        "legal-person": "Juridinis asmuo",
        "individual": "Fizinis asmuo",
        "legal-person-or-individual": "Juridinis arba fizinis asmuo"
      },
      "en": {
        "legal-person": "Legal entity",
        "individual": "Natural person",
        "legal-person-or-individual": "Legal or natural person"
      }
    },

    "actionExtraFieldType": {
      "lt": {
        "manual": "Įvedimo laukas",
        "ntr": "Nekilnojamojo turto objektas"
      },
      "en": {
        "manual": "Input field",
        "ntr": "Real estate object"
      }
    },

    "actionExtraFieldManualInputType": {
      "lt": {
        "numbers": "Skaičiai",
        "letters": "Raidės",
        "numbers_and_letters": "Be apribojimų"
      },
      "en": {
        "numbers": "Numbers",
        "letters": "Letters",
        "numbers_and_letters": "No restrictions"
      }
    },

   "whoMayConsitute": {
      "lt": {
          "fiz": "1. Paslaugos, kurias per įgaliotinį gali gauti tik fizinis asmuo (kai įgaliotiniui nereikia notarinio įgaliojimo).",
          "fiz-notarial": "2. Paslaugos, kurias per įgaliotinį gali gauti tik fizinis asmuo (kai įgaliotinis pateikia notarinį įgaliojimą).",
          "jur": "3. Paslaugos, kurias per įgaliotinį gali gauti tik juridinis asmuo (kai įgaliotiniui nereikia notarinio įgaliojimo).",
          "jur-notarial": "4. Paslaugos, kurias per įgaliotinį gali gauti tik juridinis asmuo (kai įgaliotinis pateikia notarinį įgaliojimą).",
          "fiz-jur": "5. Paslaugos, kurias per įgaliotinį gali gauti tiek fizinis, tiek juridinis asmuo (kai abiem atvejais įgaliotiniui nereikia notarinio įgaliojimo).",
          "fiz-notarial-jur-notarial": "6. Paslaugos, kurias per įgaliotinį gali gauti tiek fizinis, tiek juridinis asmuo (kai abiem atvejais įgaliotiniui reikia notarinio įgaliojimo).",
          "fiz-notarial-jur": "7. Paslaugos, kurias per įgaliotinį gali gauti tiek fizinis asmuo (kai įgaliotinis pateikia notarinį įgaliojimą), tiek juridinis asmuo (kai įgaliotiniui nereikia notarinio įgaliojimo).",
          "fiz-jur-notarial": "8. Paslaugos, kurias per įgaliotinį gali gauti tiek fizinis asmuo (kai įgaliotiniui nereikia notarinio įgaliojimo), tiek juridinis asmuo (kai įgaliotinis pateikia notarinį įgaliojimą).",
      },
      "en": {
          "fiz": "1. Services that can only be obtained by a natural person through the attorney (when the attorney does not require a notarial power of attorney).",
          "fiz-notarial": "2. Services that can only be obtained by a natural person through the attorney (when the attorney provides a notarial power of attorney).",
          "jur": "3. Services that can only be obtained by a legal entity through the attorney (when the attorney does not require a notarial power of attorney).",
          "jur-notarial": "4. Services that can only be obtained by a legal entity through the attorney (when the attorney provides a notarial power of attorney).",
          "fiz-jur": "5. Services that can be obtained through the attorney by both a natural person and a legal entity (when in both cases the attorney does not require a notarial power of attorney).",
          "fiz-notarial-jur-notarial": "6. Services that can be obtained by both a natural person and a legal entity through the attorney (when in both cases the attorney needs a notarial power of attorney).",
          "fiz-notarial-jur": "7. Services that can be obtained through the attorney both by a natural person (when the attorney provides a notary power of attorney) and by a legal entity (when the attorney does not require a notarial power of attorney).",
          "fiz-jur-notarial": "8. Services that can be obtained through the attorney both by a natural person (when the attorney does not require a notarial power of attorney) and by a legal entity (when the attorney provides a notarial power of attorney).",
      }
    },

    "digitalService": {
      "lt": {
        "digital": "Tik elektroninė paslauga",
        "analog": "Tik neelektroninė paslauga",
        "digital-or-analog": "Elektroninė arba neelektroninė paslauga"
      },
      "en": {
        "digital": "Electronic service only",
        "analog": "Non-electronic service only",
        "digital-or-analog": "Electronic or non-electronic service"
      }
    },

    "serviceType": {
      "lt": {
        "public-service": "Viešoji paslauga",
        "administrative-service": "Administracinė paslauga",
        "neither-public-nor-admin-service": "Nei viešoji, nei administracinė paslauga"
      },
      "en": {
        "public-service": "Public service",
        "administrative-service": "Administrative service",
        "neither-public-nor-admin-service": "No public or administrative service"
      }
    },

    "terms": {
      "lt": {
        "1101": "Apibrėžtas data",
        "1103": "Apibrėžtas įvykiu",
        "1102": "Neapibrėžtas"
      },
      "en": {
        "1101": "Defined by time",
        "1103": "Defined by event",
        "1102": "Undefined"
      }
    },

    "undefinedTerms": {
      "lt": {
        "1101": "Apibrėžtas data",
        "1103": "Apibrėžtas įvykiu",
      },
      "en": {
        "1101": "Defined by time",
        "1103": "Defined by event",
      }
    },

    "subterms": {
      "lt": {
        "1101": "Apibrėžtas data",
        "1103": "Apibrėžtas įvykiu",
      },
      "en": {
        "1101": "Defined by time",
        "1103": "Defined by event",
      }
    },

    "mandateTerms": {
      "lt": {
        "1101": "Apibrėžtas data",
        "1102": "Neapibrėžtas"
      },
      "en": {
        "1101": "Defined by time",
        "1102": "Undefined"
      }
    },

    "mandateUndefinedTerms": {
      "lt": {
        "1101": "Apibrėžtas data",
      },
      "en": {
        "1101": "Defined by time",
      }
    },

    "mandateSubterms": {
      "lt": {
        "1101": "Apibrėžtas data",
      },
      "en": {
        "1101": "Defined by time",
      }
    },

    // IREG reports

    "activeAction": {
      "lt": {
         "aktyvi": "Aktyvi",
         "neaktyvi": "Neaktyvi",
       },
       "en": {
         "1": "Active",
         "0": "Inactive",
       }
    },

    "usage": {
      "lt": {
         "naudota": "Naudota",
         "nenaudota": "Nenaudota",
       },
       "en": {
         "naudota": "Used",
         "nenaudota": "Not used",
       }
    },

    "submitTypes": {
      "lt": {
         "ireg": "ĮREG",
         "savitarna": "Savitarna",
       },
       "en": {
        "ireg": "ĮREG",
        "savitarna": "Savitarna",
       }
    },

    "dataSubmitTypes": {
      "lt": {
         "Sistema-sistema": "Sistema-sistema",
         "Elektroninis": "Elektroninis",
         "Popierinis": "Popierinis",
       },
       "en": {
        "Sistema-sistema": "Sistema-sistema",
        "Elektroninis": "Elektroninis",
        "Popierinis": "Popierinis",
       }
    },

    "dataProviderTypeReport": {
      "lt": {
        "notary": "Notaras",
        "court": "Teismas",
        "prison": "Bausmių vykdymo sistemos pareigūnas",
        "consul": "Konsulinis pareigūnas",
        "fiz": "Fizinis asmuo",
        "jur": "Juridinis asmuo",
       },
       "en": {
        "notary": "Notaras",
        "court": "Teismas",
        "prison": "Bausmių vykdymo sistemos pareigūnas",
        "consul": "Konsulinis pareigūnas",
        "fiz": "Fizinis asmuo",
        "jur": "Juridinis asmuo",
       }
    },

    "mandatePersonTypeReport": {
      "lt": {
        "sav": "Savivaldybė",
        "jar": "JAR registruotas asmuo",
        "gr": "GR registruotas asmuo",
        "ur": "UR registruotas asmuo",
       },
       "en": {
        "sav": "Savivaldybė",
        "jar": "JAR registruotas asmuo",
        "gr": "GR registruotas asmuo",
        "ur": "UR registruotas asmuo",
       }
    },


    // end IREG reports

    "active": {
      "lt": {
         "1": "Aktyvus",
         "0": "Neaktyvus",
       },
       "en": {
         "1": "Active",
         "0": "Inactive",
       }
    },
    "createdByRc": {
      "lt": {
        "true": "Taip",
        "false": "Ne",
       },
       "en": {
        "true": "Yes",
        "false": "No",
       }
    },
    "activeSelect": {
      "lt": {
        "": "Visos",
         "true": "Aktyvus",
         "false": "Neaktyvus",
       },
       "en": {
        "": "All",
         "true": "Active",
         "false": "Inactive",
       }
    },

    "signatureRequired": {
      "lt": {
        "": "Visi",
         "true": "Taip",
         "false": "Ne",
       },
       "en": {
        "": "All",
         "true": "Taip",
         "false": "Ne",
       }
    },

    "logic": {
      "lt": {
         "1": "T",
         "0": "N",
       },
       "en": {
         "1": "T",
         "0": "F",
       }
    },

    "logicSelect": {
      "lt": {
         "0": "Įgaliojimas atšaukiamas", // "1"
         "1": "Įgaliojimas neatšaukiamas", // "0"
       },
       "en": {
         "0": "Power of attorney is revocable", // "1"
         "1": "Power of attorney is not revocable", // "0"
       }
    },

    "roles":  {
      "lt": {
        "2779": "IR Administratorius",
        "2780": "IR Registratorius",
        "2781": "Įgaliojimų registro išsami informacija",
        "2782": "Įgaliojimų registro išsami informacija su įgaliojimo turiniu",
        "2783": "Įgaliojimų registro santrauka",
        "2784": "Įgaliojimų registro  išrašas pagal mažai paieškos kriterijų (a/k, ILTU, gimimo datą,  vardą, pavardę,  juridinio asmens kodą, užsienyje suteiktą kodą, valstybę) – išsami, išsami su turiniu, santrauka.",
        "2785": "Įgaliojimų registro paieškos pagal paslaugos kodą (išsami informacija, santrauka)",
        "2786": "Įgaliojimų registro archyvo išrašas - be įgaliojimo turinio, su įgaliojimo turiniu, su paslauga.",
        "2787": "Įgaliojimų registro archyvo išrašas pagal mažai paieškos kriterijų (a/k, ILTU, gimimo datą,  vardą, pavardę,  juridinio asmens kodą, užsienyje suteiktą kodą, valstybę) – be įgaliojimo turinio ir su įgaliojimo turiniu.",
        "2788": "Įgaliojimų registro visos paieškos RC darbuotojui",
        "EL_FA": "Fizinis asmuo",
        "EL_JA": "Juridinis asmuo",
      },
      "en": {
        "2779": "IR Administratorius",
        "2780": "IR Registratorius",
        "2781": "Įgaliojimų registro išsami informacija",
        "2782": "Įgaliojimų registro išsami informacija su įgaliojimo turiniu",
        "2783": "Įgaliojimų registro santrauka",
        "2784": "Įgaliojimų registro  išrašas pagal mažai paieškos kriterijų (a/k, ILTU, gimimo datą,  vardą, pavardę,  juridinio asmens kodą, užsienyje suteiktą kodą, valstybę) – išsami, išsami su turiniu, santrauka.",
        "2785": "Įgaliojimų registro paieškos pagal paslaugos kodą (išsami informacija, santrauka)",
        "2786": "Įgaliojimų registro archyvo išrašas - be įgaliojimo turinio, su įgaliojimo turiniu, su paslauga.",
        "2787": "Įgaliojimų registro archyvo išrašas pagal mažai paieškos kriterijų (a/k, ILTU, gimimo datą,  vardą, pavardę,  juridinio asmens kodą, užsienyje suteiktą kodą, valstybę) – be įgaliojimo turinio ir su įgaliojimo turiniu.",
        "2788": "Įgaliojimų registro visos paieškos RC darbuotojui",
        "EL_FA": "Natural person",
        "EL_JA": "Legal entity",
      }
    },

    "mandateKindMandateSearch":  {
      "lt": {
        "itpsi": "Elektroninis įgaliojimas",
        "ntpi": "Notarinis ar kt. įgaliojimas",
      },
      "en": {
        "itpsi": "Electronic power of attorney",
        "ntpi": "Notarial or other power of attorney",
      }
    },

    "mandateKind":  {
      "lt": {
        "itpsi": "Elektroninis įgaliojimas",
        "ntpi": "Notarinis ar kt. įgaliojimas",
        "pp": "Prokūra",
      },
      "en": {
        "itpsi": "Electronic power of attorney",
        "ntpi": "Notarial or other power of attorney",
        "pp": "Procuracy",
      }
    },

    "mandateStatusSelfService": {
      "lt": {
        "1602": "Įregistruotas",
        "1604": "Išregistruotas",
      },
      "en": {
        "1602": "Registered",
        "1604": "Deregistered",
      },
    },

    "mandateStatus":{
      "lt": {
        "1601": "Rengiamas",
        "1602": "Įregistruotas",
        "1603": "Atmestas",
        "1604": "Išregistruotas",
      },
      "en": {
        "1601": "Under preparation",
        "1602": "Registered",
        "1603": "Rejected",
        "1604": "Deregistered",
      },
    },

    "journalType":{
      "lt": {
        "801": "Rengiamas",
        "802": "Priimtas",
        "803": "Atmestas",
        "804": "Laukia apmokėjimo",
        "806": "Laukia patvirtinimo",
        "807": "Apmokėta ir vykdoma",
        "808": "Įvykdytas",
        "809": "Laukia pasirašymo",
        "810": "Atšauktas",
        "811": "Atsisakyta pasirašyti",
        "812": "Atmestas",
        "813": "Atstovų tikrinimas",
        "814": "Atstovai patvirtinti",
        "815": "Atstovai netinkami",
        "816": "Atsisakytas vykdyti",
      },
      "en": {
        "801": "Under preparation",
        "802": "Accepted",
        "803": "Rejected",
        "804": "Awaiting payment",
        "806": "Awaiting confirmation",
        "807": "Paid and in progress",
        "808": "Completed",
        "809": "Awaiting signature",
        "810": "Cancelled",
        "811": "Refused to sign",
        "812": "Rejected",
        "813": "Verification of representatives",
        "814": "Representatives confirmed",
        "815": "Representatives not eligible",
        "816": "Refused to process",
      }
    },

    "operationType": {
      "lt": {
        "together": "Veikia kartu",
        "separately": "Veikia atskirai",
      },
      "en": {
        "together": "Works together",
        "separately": "Works apart",
      }
    },

    "outJournalType":{
      "lt": {
        "1426": "Pranešimas apie išrašo užsakymo užregistravimą (SMS/EMAIL)",
        "1427": "Pranešimas apie išrašo užsakymo įvykdymą (SMS/EMAIL)",
        "1428": "Pranešimas apie atsisakymą išduoti išrašą (SMS/EMAIL)",
        "1429": "Pranešimas apie prašymo perdavimą į Registrą (SMS/EMAIL)",
        "1430": "Pranešimas apie objekto įregistravimą (SMS/EMAIL)",
        "1431": "Pranešimas apie objekte asmens atžvilgiu įrašomą pasibaigimo požymį (SMS/EMAIL)",
        "1432": "Pranešimas apie objekto išregistravimą (SMS/EMAIL)",
        "1433": "Pranešimas apie atsisakymą įrašyti į ĮR (SMS/EMAIL)",
        "1434": "Pranešimas apie atstovų tikrinimą (SMS/EMAIL)",
        "1435": "Pranešimas apie atstovų tikrinimą (registratorius priima neigiamą sprendimą) (SMS/EMAIL)",
        "1436": "Pranešimas apie sekančio asmens pasirašymą (SMS/EMAIL)",
        "1437": "Pranešimas apie įgaliojimo/prokūros pasirašymo procesą (SMS/EMAIL)",
        "1438": "Pranešimas apie įgaliojimo/prokūros pasirašymo procesą (atšaukimas) (SMS/EMAIL)",
        "1439": "Pranešimas apie įgaliojimo/prokūros pasirašymo procesą (atsisakymas pasirašyti) (SMS/EMAIL)",
        "1440": "Pranešimas apie sustabdymą (SMS/EMAIL)",
        "1441": "Pranešimas apie sustabdymo panaikinimą (SMS/EMAIL)",
        "1442": "Pranešimas apie laukiamą paslaugos apmokėjimą (SMS/EMAIL)",
        "1499": "Kiti  (SMS/EMAIL)",
        "1408": "Pranešimas apie atsisakymą įregistruoti įgaliojimą / įrašyti duomenis įgaliojimų registre",
        "1411": "Pranešimas apie įgaliojimo įregistravimą Įgaliojimų registre",
        "1412": "Pranešimas apie įgaliojimo išregistravimą iš Įgaliojimų registro",
        "1413": "Pranešimas apie įgaliojimo pasibaigimo įgaliotojo atžvilgiu požymio įrašymą Įgaliojimų registre",
        "1414": "Pranešimas apie įgaliojimo pasibaigimo įgaliotinio atžvilgiu požymio įrašymą Įgaliojimų registre",
        "1415": "Pranešimas apie prokūros įregistravimą Įgaliojimų registre",
        "1416": "Pranešimas apie prokūros išregistravimą Įgaliojimų registre",
        "1417": "Pranešimas apie prokūros galiojimo sustabdymo duomenų įrašymą įgaliojimų registre",
        "1418": "Pranešimas apie prokūros galiojimo sustabdymo panaikinimo duomenų įrašymą įgaliojimų registre",
        "1419": "Pranešimas apie atsisakymą įregistruoti prokūrą / įrašyti duomenis Įgaliojimų registre",
        "1420": 'Pranešimas apie įgaliojimo pakeitimo duomenų įrašymą Įgaliojimų registre',
        "1421": "Pranešimas apie įgaliojimo galiojimo sustabdymo duomenų įrašymą įgaliojimų registre",
        "1422": "Pranešimas apie įgaliojimo galiojimo sustabdymo panaikinimo duomenų įrašymą įgaliojimų registre",
        "1423": "Pranešimas apie įgaliojimų registro duomenų ištaisymą",
        "1424": "Pranešimas apie įgaliojimų registro duomenų ištaisymą išregistruojant įgaliojimą",
        "1425": "Pranešimas apie įgaliojimo, duoto perįgaliojant, pasibaigimo asmens, pripažinto neveiksniu ar kurio civilinis veiksnumas apribotas toje srityje, kurioje duotas įgaliojimas, atžvilgiu požymio įrašymą Įgaliojimų registre",
      },
      "en": {
        "1426": "Notification regarding the registration of an order for the excerpt (SMS/EMAIL)",
        "1427": "Notification regarding the completion of an order for the excerpt (SMS/EMAIL)",
        "1428": "Notification regarding the refusal to issue an excerpt (SMS/EMAIL)",
        "1429": "Pranešimas apie prašymo perdavimą į Registrą (SMS/EMAIL)",
        "1430": "Pranešimas apie objekto įregistravimą (SMS/EMAIL)",
        "1431": "Pranešimas apie objekte asmens atžvilgiu įrašomą pasibaigimo požymį (SMS/EMAIL)",
        "1432": "Pranešimas apie objekto išregistravimą (SMS/EMAIL)",
        "1433": "Pranešimas apie atsisakymą įrašyti į ĮR (SMS/EMAIL)",
        "1434": "Pranešimas apie atstovų tikrinimą (SMS/EMAIL)",
        "1435": "Pranešimas apie atstovų tikrinimą (registratorius priima neigiamą sprendimą) (SMS/EMAIL)",
        "1436": "Pranešimas apie sekančio asmens pasirašymą (SMS/EMAIL)",
        "1437": "Pranešimas apie įgaliojimo/prokūros pasirašymo procesą (SMS/EMAIL)",
        "1438": "Pranešimas apie įgaliojimo/prokūros pasirašymo procesą (atšaukimas) (SMS/EMAIL)",
        "1439": "Pranešimas apie įgaliojimo/prokūros pasirašymo procesą (atsisakymas pasirašyti) (SMS/EMAIL)",
        "1440": "Pranešimas apie sustabdymą (SMS/EMAIL)",
        "1441": "Pranešimas apie sustabdymo panaikinimą (SMS/EMAIL)",
        "1442": "Pranešimas apie laukiamą paslaugos apmokėjimą (SMS/EMAIL)",
        "1499": "Kiti  (SMS/EMAIL)",
        "1408": "Notice of a refusal to register/enter data into the Register of Powers of Attorney",
        "1411": "Notice of a power of attorney's registration in the Register of Powers of Attorney",
        "1412": "Notice of a power of attorney's deregistration from the Register of Powers of Attorney",
        "1413": "Notice of an entry of the attribute in regards to an end of the role of principal in the Register of Powers of Attorney",
        "1414": "Notice of an entry of the attribute in regards to an end of the role of attorney in the Register of Powers of Attorney",
        "1415": "Notification of the registration of procuracy in the register of powers of attorneys",
        "1416": "Notification of removal of procuracy from the register of powers of attorneys",
        "1417": "Notification of data entry on suspension of procuracy in the register of powers of attorneys",
        "1418": "Notification of data entry on removal of suspension of procuracy in the register of powers of attorneys",
        "1419": "Notice of a refusal to register/enter data into the Register of Powers of Attorney",
        "1420": 'Notification of entry of amendment data of power of attorney in the register of powers of attorney',
        "1421": "Notification of data entry on suspension of power of attorney in the register of powers of attorney",
        "1422": "Notification of data entry on removal of suspension of power of attorney in the register of powers of attorney",
        "1423": "Notification of the correction of data in the register of powers of attorney",
        "1424": "Notification of the correction of data in the register of powers of attorney by deregistering the power of attorney",
        "1425": "Notice of an entry of the attribute into the Register of Powers of Attorney of a person who was declared legally incapable or whose civil capacity was restricted in the area in which the power of attorney was given, in regards to an end of the POA granted by sub-delegation",
      }
    },

    "outJournalTypeSav":{
      "lt": {
        "1408": "Pranešimas apie atsisakymą įregistruoti įgaliojimą / įrašyti duomenis įgaliojimų registre",
        "1411": "Pranešimas apie įgaliojimo įregistravimą Įgaliojimų registre",
        "1412": "Pranešimas apie įgaliojimo išregistravimą iš Įgaliojimų registro",
        "1413": "Pranešimas apie įgaliojimo pasibaigimo įgaliotojo atžvilgiu požymio įrašymą Įgaliojimų registre",
        "1414": "Pranešimas apie įgaliojimo pasibaigimo įgaliotinio atžvilgiu požymio įrašymą Įgaliojimų registre",
        "1415": "Pranešimas apie prokūros įregistravimą Įgaliojimų registre",
        "1416": "Pranešimas apie prokūros išregistravimą Įgaliojimų registre",
        "1417": "Pranešimas apie prokūros galiojimo sustabdymo duomenų įrašymą įgaliojimų registre",
        "1418": "Pranešimas apie prokūros galiojimo sustabdymo panaikinimo duomenų įrašymą įgaliojimų registre",
        "1419": "Pranešimas apie atsisakymą įregistruoti prokūrą / įrašyti duomenis Įgaliojimų registre",
        "1420": "Pranešimas apie įgaliojimo pakeitimo duomenų įrašymą Įgaliojimų registre",
        "1421": "Pranešimas apie įgaliojimo galiojimo sustabdymo duomenų įrašymą įgaliojimų registre",
        "1422": "Pranešimas apie įgaliojimo galiojimo sustabdymo panaikinimo duomenų įrašymą įgaliojimų registre",
        "1423": "Pranešimas apie įgaliojimų registro duomenų ištaisymą",
        "1424": "Pranešimas apie įgaliojimų registro duomenų ištaisymą išregistruojant įgaliojimą",
        "1425": "Pranešimas apie įgaliojimo, duoto perįgaliojant, pasibaigimo asmens, pripažinto neveiksniu ar kurio civilinis veiksnumas apribotas toje srityje, kurioje duotas įgaliojimas, atžvilgiu požymio įrašymą Įgaliojimų registre",
      },
      "en": {
        "1408": "Notice of a refusal to register/enter data into the Register of Powers of Attorney",
        "1411": "Notice of a power of attorney's registration in the Register of Powers of Attorney",
        "1412": "Notice of a power of attorney's deregistration from the Register of Powers of Attorney",
        "1413": "Notice of an entry of the attribute in regards to an end of the role of principal in the Register of Powers of Attorney",
        "1414": "Notice of an entry of the attribute in regards to an end of the role of attorney in the Register of Powers of Attorney",
        "1415": "Notification of the registration of procuracy in the register of powers of attorneys",
        "1416": "Notification of removal of procuracy from the register of powers of attorneys",
        "1417": "Notification of data entry on suspension of procuracy in the register of powers of attorneys",
        "1418": "Notification of data entry on removal of suspension of procuracy in the register of powers of attorneys",
        "1419": "Notice of a refusal to register/enter data into the Register of Powers of Attorney",
        // "1420": "Notification of refusal to enter data on termination of procuracy in the register of powers of attorney",
        "1421": "Notification of data entry on suspension of power of attorney in the register of powers of attorney",
        "1422": "Notification of data entry on removal of suspension of power of attorney in the register of powers of attorney",
        "1423": "Notification of the correction of data in the register of powers of attorney",
        "1424": "Notification of the correction of data in the register of powers of attorney by deregistering the power of attorney",
        "1425": "Notice of an entry of the attribute into the Register of Powers of Attorney of a person who was declared legally incapable or whose civil capacity was restricted in the area in which the power of attorney was given, in regards to an end of the POA granted by sub-delegation",
      }
    },

    "checkingStatus": {
      "lt": {
        "0": "-",
        "1": "Netinkamas",
        "2": "Tinkamas"
      },
      "en": {
        "0": "-",
        "1": "Netinkamas",
        "2": "Tinkamas"
      }
    },

    "historyStatus":{
      "lt": {
      // inJournalStatus
        "808": "Įvykdytas",
        "802": "Priimtas",
        "803": "Atmestas",
        "816": "Atsisakytas vykdyti",
      //
        "809": "Laukia pasirašymo",
        "810": "Atšauktas",
        "811": "Atsisakyta pasirašyti",
        "812": "Atmestas",
      // msgStatusTypes
        "01": "Išsiųstas",
        "02": "Išsaugotas",
      },
      "en":{
      // inJournalStatus
        "808": "Completed",
        "802": "Accepted",
        "803": "Rejected",
        "816": "Refused to process",
      //
        "809": "Laukia pasirašymo",
        "810": "Atšauktas",
        "811": "Atsisakyta pasirašyti",
        "812": "Atmestas",
      // msgStatusTypes
        "01": "Sent",
        "02": "Not sent",
      }
    },

    "inJournalStatusMessages": {
      "lt": {
        "816": "Atsisakyta vykdyti",
        "808": "Įvykdytas",
        "802": "Priimtas",
        "801": "Rengiamas",
      },
      "en":{
        "802": "Accepted",
        "808": "Completed",
        "801": "Filling",
        "816": "Refused to process",
      }
    },

    "inJournalStatus": {
      "lt": {
        "803": "Atmestas",
        "816": "Atsisakyta vykdyti",
        "808": "Įvykdytas",
        "802": "Priimtas",
      },
      "en":{
        "802": "Accepted",
        "808": "Completed",
        "816": "Refused to process",
        "803": "Rejected",
      }
    },

    "checkingInJournalStatuses": {
      "lt": {
        "407": "Įgaliojimo projektas",
        "408": "Įgaliotojo prašymas dėl įgaliojimo pabaigos",
        "409": "Įgaliotinio prašymas dėl įgaliojimo pabaigos",
        "420": "Prokūros projektas",
        "422": "Prokūrą išdavusio juridinio asmens prašymas dėl prokūros pabaigos",
        "423": "Prokuristo prašymas dėl prokūros pabaigos",
      },
      "en": {
        "407": "Power of attorney project",
        "408": "Request of a principal to the Register of Powers of Attorney in regards to a termination of the power of attorney",
        "409": "Request of an attorney to the Register of Powers of Attorney in regards to a termination of the power of attorney",
        "420": "Draft procuracy",
        "422": "Application of legal entity granting procuracy to terminate procuracy",
        "423": "Application of procurator to terminate procuracy",
      },
    },
    "historyType":{
      "lt": {
        // inJournalType
        "401": "Pranešimas Įgaliojimų registrui apie įgaliojimo patvirtinimą",
        "402": "Pranešimas Įgaliojimų registrui apie įgaliojimo pakeitimą",
        "403": "Tarnybinis pranešimas apie registro duomenų netikslumus",
        "404": "Pranešimas apie įgaliojimo pasibaigimą",
        "405": "Tarnybinis pranešimas apie klaidingai įregistruotą objektą",
        "406": "Automatinis išregistravimas",
        "407": "Įgaliojimas",
        "420": "Prokūra",
        "421": "Prokūrą išdavusio juridinio asmens prašymas dėl prokūros įregistravimo",
        "422": "Prokūrą išdavusio juridinio asmens prašymas dėl prokūros pabaigos",
        "423": "Prokuristo prašymas dėl prokūros pabaigos",
        "408": "Įgaliotojo prašymas dėl įgaliojimo pabaigos",
        "409": "Įgaliotinio prašymas dėl įgaliojimo pabaigos",
        "410": "Pranešimas apie informacinių technologijų priemonėmis sudaryto įgaliojimo pasibaigimą",
        "411": "Pranešimas Įgaliojimų registrui apie įgaliotojo arba įgaliotinio pripažinimą nežinia kur esančiu",
        "412": "Įgaliojimas, duotas perįgaliojant",
        "413": "Pranešimas Įgaliojimų registrui iš Gyventojų registro apie įrašytą asmens mirtį (GR)",
        "414": "Pranešimas Įgaliojimų registrui iš Neveiksnių ir ribotai veiksnių asmenų registro apie asmens pripažinimą neveiksniu ar ribotai veiksniu (NIRVAR)",
        "415": "Pranešimas Įgaliojimų registrui iš Juridinių asmenų registro apie juridinio asmens išregistravimą (JAR)",
        "416": "Pranešimas Įgaliojimų registrui iš Juridinių asmenų registro apie juridinio asmens teisinio statuso įregistravimą (JAR)",
        "417": "Pranešimas Įgaliojimų registrui apie Įgaliojimų registro objekto termino pasibaigimą",
        "418": "Pranešimas Įgaliojimų registrui apie Įgaliojimo, kuris buvo perįgaliotas, išregistravimą",
        "424": 'Pranešimas Įgaliojimų registrui apie įgaliojimo pasibaigimą',
        "425": 'Pranešimas Įgaliojimų registrui apie prokūros pasibaigimą',
        "426": 'Pranešimas Įgaliojimų registrui apie įgaliojimo galiojimo sustabdymą',
        "427": 'Pranešimas Įgaliojimų registrui apie prokūros galiojimo sustabdymą',
        "428": 'Pranešimas Įgaliojimų registrui apie įgaliojimo galiojimo sustabdymo panaikinimą',
        "429": 'Pranešimas Įgaliojimų registrui apie prokūros galiojimo sustabdymo panaikinimą',
        "430": 'Pranešimas Įgaliojimų registrui apie prokuristo pripažinimą nežinia kur esančiu',
        // out
        "1401": "Pranešimas apie atsisakymą įregistruoti įgaliojimą",
        "1402": "Pranešimas apie atsisakymą įrašyti duomenis registre",
        "1403": "Pranešimas apie įgaliojimo įregistravimą registre",
        "1404": "Pranešimas apie įgaliojimo išregistravimą iš registro",
        "1405": "Pranešimas apie įgaliojimo duomenų pakeitimo įrašymą registre",
        "1406": "Pranešimas apie įgaliojimo įregistravimą",
        "1407": "Pranešimas apie įgaliojimo išregistravimą",
        "1408": "Pranešimas apie atsisakymą įregistruoti įgaliojimą / įrašyti duomenis Įgaliojimų registre",
        "1409": "Pranešimas apie informacinių technologijų priemonėmis sudaryto įgaliojimo išregistravimą iš įgaliojimų registro",
        "1411": "Pranešimas apie įgaliojimo įregistravimą Įgaliojimų registre",
        "1412": "Pranešimas apie įgaliojimo išregistravimą iš Įgaliojimų registro",
        "1413": "Pranešimas apie įgaliojimo pasibaigimo įgaliotojo atžvilgiu požymio įrašymą Įgaliojimų registre",
        "1414": "Pranešimas apie įgaliojimo pasibaigimo įgaliotinio atžvilgiu požymio įrašymą Įgaliojimų registre",
        "1415": "Pranešimas apie prokūros įregistravimą Įgaliojimų registre",
        "1416": "Pranešimas apie prokūros išregistravimą Įgaliojimų registre",
        "1417": "Pranešimas apie prokūros galiojimo sustabdymo duomenų įrašymą įgaliojimų registre",
        "1418": "Pranešimas apie prokūros galiojimo sustabdymo panaikinimo duomenų įrašymą įgaliojimų registre",
        "1419": "Pranešimas apie atsisakymą įregistruoti prokūrą / įrašyti duomenis Įgaliojimų registre",
        "1420": "Pranešimas apie įgaliojimo pakeitimo duomenų įrašymą Įgaliojimų registre",
        "1421": "Pranešimas apie įgaliojimo galiojimo sustabdymo duomenų įrašymą įgaliojimų registre",
        "1422": "Pranešimas apie įgaliojimo galiojimo sustabdymo panaikinimo duomenų įrašymą įgaliojimų registre",
        "1423": "Pranešimas apie įgaliojimų registro duomenų ištaisymą",
        "1424": "Pranešimas apie įgaliojimų registro duomenų ištaisymą išregistruojant įgaliojimą",
        "1425": "Pranešimas apie įgaliojimo, duoto perįgaliojant, pasibaigimo asmens, pripažinto neveiksniu ar kurio civilinis veiksnumas apribotas toje srityje, kurioje duotas įgaliojimas, atžvilgiu požymio įrašymą Įgaliojimų registre",
      },
      "en": {
        // inJournalType
        "401": "Notice of the approval of the power of attorney in the Register of Powers of Attorney",
        "402": "Notice of the amendment to the power of attorney in the Register of Powers of Attorney",
        "403": "Report on inaccuracies in the Register data",
        "404": "Notice of the expiry of the power of attorney",
        "405": "Report on the erroneously registered object",
        "406": "Automatic deregistration",
        "407": "Power of attorney",
        "420": "Procuracy",
        "421": "Application of legal entity granting procuracy to register procuracy",
        "422": "Application of legal entity granting procuracy to terminate procuracy",
        "423": "Application of procurator to terminate procuracy",
        "408": "Request of a principal to the Register of Powers of Attorney in regards to a termination of the power of attorney",
        "409": "Request of an attorney to the Register of Powers of Attorney in regards to a termination of the power of attorney",
        "410": "Notice of the expiry of the power of attorney created electronically",
        "411": "Notice to the Register of Powers of Attorney recognising principal or attorney as a missing person",
        "412": "Power of attorney issued by sub-delegation",
        "413": "Notice to the Register of Powers of Attorney from the Population Register of a recorded death of a person (GR)",
        "414": "Notice to the Register of Powers of Attorney from the Register of Legally Incapable Persons and Persons with Limited Legal Capacity in regards to a person’s recognition as legally incapable or with limited legal capacity (NIRVAR)",
        "415": "Notice to the Register of Powers of Attorney from the Register of Legal Entities about deregistration of a legal entity (JAR)",
        "416": "Notice to the Register of Powers of Attorney from the Register of Legal Entities about registration of a legal entity (JAR)",
        "417": "Notice to the Register of Powers of Attorney of the expiry of the term of the object of the Register",
        "418": "Notification to the Register of Powers of Attorney on the deregistration of the power of attorney, which was granted by re-authorisation",
        "424": "Notification to the register of powers of attroney on the termination of power of attorney",
        "425": "Notification to the register of powers of attroney on the termination of procuracy",
        "426": "Notification to the register of powers of attroney on the suspension of power of attorney",
        "427": "Notification to the register of powers of attroney on the suspension of procuracy",
        "428": "Notification to the register of powers of attroney on the removal of suspension of power of attorney",
        "429": "Notification to the register of powers of attroney on the removal of suspension of procuracy",
        "430": "Notification to the register of powers of attroney on declaring the procurator missing",
        // out
        "1401": "Notification regarding the refusal to register the power of attorney",
        "1402": "Notification regarding the refusal to enter data in the Register",
        "1403": "Notification regarding the registration of the power of attorney in the Register",
        "1404": "Notification regarding the removal of the power of attorney from the Register",
        "1405": "Notification regarding the recording of data change in the power of attorney in the Register",
        "1406": "Notification regarding the registration of the power of attorney",
        "1407": "Notification regarding the deregistration of the power of attorney",
        "1408": "Notice of a refusal to register/enter data into the Register of Powers of Attorney",
        "1409": "Notification regarding the removal of the power of attorney from the Register created by means of information technologies",
        "1411": "Notice of a power of attorney's registration in the Register of Powers of Attorney",
        "1412": "Notice of a power of attorney's deregistration from the Register of Powers of Attorney",
        "1413": "Notice of an entry of the attribute in regards to an end of the role of principal in the Register of Powers of Attorney",
        "1414": "Notice of an entry of the attribute in regards to an end of the role of attorney in the Register of Powers of Attorney",
        "1415": "Notification of the registration of procuracy in the register of powers of attorneys",
        "1416": "Notification of removal of procuracy from the register of powers of attorneys",
        "1417": "Notification of data entry on suspension of procuracy in the register of powers of attorneys",
        "1418": "Notification of data entry on removal of suspension of procuracy in the register of powers of attorneys",
        "1419": "Notice of a refusal to register/enter data into the Register of Powers of Attorney",
        "1420": 'Notification of entry of amendment data of power of attorney in the register of powers of attorney',
        "1421": "Notification of data entry on suspension of power of attorney in the register of powers of attorney",
        "1422": "Notification of data entry on removal of suspension of power of attorney in the register of powers of attorney",
        "1423": "Notification of the correction of data in the register of powers of attorney",
        "1424": "Notification of the correction of data in the register of powers of attorney by deregistering the power of attorney",
        "1425": "Notice of an entry of the attribute into the Register of Powers of Attorney of a person who was declared legally incapable or whose civil capacity was restricted in the area in which the power of attorney was given, in regards to an end of the POA granted by sub-delegation",
      }
    },

    "inJournalType": {
      "lt": {
        "401": "Pranešimas Įgaliojimų registrui apie įgaliojimo patvirtinimą",
        "402": "Pranešimas Įgaliojimų registrui apie įgaliojimo pakeitimą",
        "403": "Tarnybinis pranešimas apie registro duomenų netikslumus",
        "404": "Pranešimas apie įgaliojimo pasibaigimą",
        "405": "Tarnybinis pranešimas apie klaidingai įregistruotą objektą",
        "406": "Automatinis išregistravimas",
        "407": "Įgaliojimo projektas",
        "408": "Įgaliotojo prašymas dėl įgaliojimo pabaigos",
        "409": "Įgaliotinio prašymas dėl įgaliojimo pabaigos",
        "410": "Pranešimas apie informacinių technologijų priemonėmis sudaryto įgaliojimo pasibaigimą",
        "411": "Pranešimas Įgaliojimų registrui apie įgaliotojo arba įgaliotinio pripažinimą nežinia kur esančiu",
        "412": "Įgaliojimas, duotas perįgaliojant",
        "413": "Pranešimas Įgaliojimų registrui iš Gyventojų registro apie įrašytą asmens mirtį (GR)",
        "414": "Pranešimas Įgaliojimų registrui iš Neveiksnių ir ribotai veiksnių asmenų registro apie asmens pripažinimą neveiksniu ar ribotai veiksniu (NIRVAR)",
        "415": "Pranešimas Įgaliojimų registrui iš Juridinių asmenų registro apie juridinio asmens išregistravimą (JAR)",
        "416": "Pranešimas Įgaliojimų registrui iš Juridinių asmenų registro apie juridinio asmens teisinio statuso įregistravimą (JAR)",
        "417": "Pranešimas Įgaliojimų registrui apie Įgaliojimų registro objekto termino pasibaigimą",
        "418": "Pranešimas Įgaliojimų registrui apie Įgaliojimo, kuris buvo perįgaliotas, išregistravimą",
        "420": "Prokūros projektas",
        "421": "Prokūrą išdavusio juridinio asmens prašymas dėl prokūros įregistravimo",
        "422": "Prokūrą išdavusio juridinio asmens prašymas dėl prokūros pabaigos",
        "423": "Prokuristo prašymas dėl prokūros pabaigos",
        "424": 'Pranešimas Įgaliojimų registrui apie įgaliojimo pasibaigimą',
        "425": 'Pranešimas Įgaliojimų registrui apie prokūros pasibaigimą',
        "426": 'Pranešimas Įgaliojimų registrui apie įgaliojimo galiojimo sustabdymą',
        "427": 'Pranešimas Įgaliojimų registrui apie prokūros galiojimo sustabdymą',
        "428": 'Pranešimas Įgaliojimų registrui apie įgaliojimo galiojimo sustabdymo panaikinimą',
        "429": 'Pranešimas Įgaliojimų registrui apie prokūros galiojimo sustabdymo panaikinimą',
        "430": 'Pranešimas Įgaliojimų registrui apie prokuristo pripažinimą nežinia kur esančiu',
        "499": "Pranešimas Įgaliojimų registrui apie asmens pripažinimą nežinia kur esančiu",
      },
      "en": {
        "401": "Notice of the approval of the power of attorney in the Register of Powers of Attorney",
        "402": "Notice of the amendment to the power of attorney in the Register of Powers of Attorney",
        "403": "Report on inaccuracies in the Register data",
        "404": "Notice of the expiry of the power of attorney",
        "405": "Report on the erroneously registered object",
        "406": "Automatic deregistration",
        "407": "Power of attorney project",
        "408": "Request of a principal to the Register of Powers of Attorney in regards to a termination of the power of attorney",
        "409": "Request of an attorney to the Register of Powers of Attorney in regards to a termination of the power of attorney",
        "410": "Notice of the expiry of the power of attorney created electronically",
        "411": "Notice to the Register of Powers of Attorney recognising principal or attorney as a missing person",
        "412": "Power of attorney issued by sub-delegation",
        "413": "Notice to the Register of Powers of Attorney from the Population Register of a recorded death of a person (GR)",
        "414": "Notice to the Register of Powers of Attorney from the Register of Legally Incapable Persons and Persons with Limited Legal Capacity in regards to a person’s recognition as legally incapable or with limited legal capacity (NIRVAR)",
        "415": "Notice to the Register of Powers of Attorney from the Register of Legal Entities about deregistration of a legal entity (JAR)",
        "416": "Notice to the Register of Powers of Attorney from the Register of Legal Entities about registration of a legal entity (JAR)",
        "417": "Notice to the Register of Powers of Attorney of the expiry of the term of the object of the Register",
        "418": "Notification to the Register of Powers of Attorney on the deregistration of the power of attorney, which was granted by re-authorisation",
        "420": "Draft procuracy",
        "421": "Application of legal entity granting procuracy to register procuracy",
        "422": "Application of legal entity granting procuracy to terminate procuracy",
        "423": "Application of procurator to terminate procuracy",
        "424": "Notification to the register of powers of attroney on the termination of power of attorney",
        "425": "Notification to the register of powers of attroney on the termination of procuracy",
        "426": "Notification to the register of powers of attroney on the suspension of power of attorney",
        "427": "Notification to the register of powers of attroney on the suspension of procuracy",
        "428": "Notification to the register of powers of attroney on the removal of suspension of power of attorney",
        "429": "Notification to the register of powers of attroney on the removal of suspension of procuracy",
        "430": "Notification to the register of powers of attroney on declaring the procurator missing",
        "499": "Notification to the register of powers of attroney on declaring the person missing",
      }
    },

    "inJournalTypeSearch": {
      "lt": {
        "407": "Įgaliojimo projektas",
        "408": "Įgaliotojo prašymas dėl įgaliojimo pabaigos",
        "409": "Įgaliotinio prašymas dėl įgaliojimo pabaigos",
        "412": "Įgaliojimas, duotas perįgaliojant",
        "420" : "Prokūros projektas",
        "421": "Prokūrą išdavusio juridinio asmens prašymas dėl prokūros įregistravimo",
        "422": "Prokūrą išdavusio juridinio asmens prašymas dėl prokūros pabaigos",
        "423": "Prokuristo prašymas dėl prokūros pabaigos",
      },
      "en": {
        "407": "Power of attorney project",
        "408": "Request of a principal to the Register of Powers of Attorney in regards to a termination of the power of attorney",
        "409": "Request of an attorney to the Register of Powers of Attorney in regards to a termination of the power of attorney",
        "412": "Power of attorney issued by sub-delegation",
        "420" : "Draft procuracy",
        "421": "Application of legal entity granting procuracy to register procuracy",
        "422": "Application of legal entity granting procuracy to terminate procuracy",
        "423": "Application of procurator to terminate procuracy",
      }
    },

    "inJournalBasis": {
      "lt": {
        "principal-refuse-mandate":	"Įgaliotojui panaikinus įgaliojimą",
        "representitive-refuse-mandate": "Įgaliotiniui atsisakius įgaliojimo",
        "court-principal-missing": "Teismo sprendimu įgaliotoją pripažinus nežinia kur esančiu",
        "court-representitive-missing":	"Teismo sprendimu įgaliotinį pripažinus nežinia kur esančiu",
        "court-invalid-mandate": "Teismo sprendimu pripažinus įgaliojimą negaliojančiu",
        "court-reject-mandate":	"Teismo sprendimu panaikinus įgaliojimą",
        "mandate-ended-by-term-date":	"Pasibaigus kalendorine data ar metais, mėnesiais, savaitėmis ir dienomis apibrėžtam įgaliojimo terminui",
        "mandate-ended-by-undefined":	"Suėjus vieniems metams nuo įgaliojimo, kuriame nenurodytas galiojimo terminas, sudarymo",
        "principal-died":	"Mirus įgaliotojui",
        "representitive-died": "Mirus įgaliotiniui",
        "procurator-incapable": "Pripažinus prokuristą neveiksniu arba ribotai veiksniu srityje, kurioje duota prokūra",
        "principal-incapable": "Pripažinus įgaliotoją neveiksniu arba ribotai veiksniu srityje, kurioje duotas įgaliojimas",
        "representitive-incapable":	"Pripažinus įgaliotinį neveiksniu arba ribotai veiksniu srityje, kurioje duotas įgaliojimas",
        "principal-is-deregistered": "Juridinį asmenį, kuris davė įgaliojimą, išregistravus iš Juridinių asmenų registro",
        "representitive-is-deregistered":	"Juridinį asmenį, kuriam duotas įgaliojimas, išregistravus iš Juridinių asmenų registro",
        "representitive-bankrupt": "Juridiniam asmeniui, kuriam duotas įgaliojimas, įgijus teisinį statusą „bankrutuojantis“",
        "parent-is-deregistered": "Pasibaigus įgaliojimui, kuris buvo perįgaliotas",
        'ja-refuse-mandate': 'Prokūrą išdavusiam juridiniam asmeniui atšaukus prokūrą',
        'procurator-refuse-mandate': 'Prokuristui atsisakius prokūros',
        'court-procurator-missing': 'Teismo sprendimu prokuristą pripažinus nežinia kur esančiu',
        'end-of-mandate': 'Teismo sprendimu pripažinus įgaliojimą negaliojančiu',
        'end-of-procuracy': 'Teismo sprendimu pripažinus prokūrą negaliojančia',
        'suspended-mandate': 'Įgaliojimas sustabdytas',
        'suspended-procuracy': 'Prokūra sustabdyta',
        'cancel-suspension-mandate': 'Įgaliojimo sustabdymas panaikintas',
        'cancel-suspension-procuracy': 'Prokūros sustabdymas panaikintas',
      },
      "en": {
        "principal-refuse-mandate":	"When principal revokes a power of attorney",
        "representitive-refuse-mandate": "When attorney waives a power of attorney",
        "court-principal-missing": "When court recognises the principal as a missing person",
        "court-representitive-missing":	"When court recognises the attorney as missing person",
        "court-invalid-mandate": "When a power of attorney is declared invalid by the court decision ",
        "court-reject-mandate":	"When a power of attorney is revoked by the court decision",
        "mandate-ended-by-term-date":	"When the term of power of attorney expires at the predefined date or year, months, weeks and days",
        "mandate-ended-by-undefined":	"One year after the conclusion of the power of attorney without the predefined term of validity",
        "principal-died":	"Upon the death of a principal",
        "representitive-died": "Upon the death of an attorney",
        "principal-incapable": "If the principal is found legally incapable or of a limited legal capacity in the area in which the power of attorney was granted",
        "representitive-incapable":	"If the attorney is found legally incapable or of a limited legal capacity in the area in which the power of attorney was granted",
        "principal-is-deregistered": "When a legal entity which has set up a power of attorney is deregistered from the Register of Legal Entities",
        "representitive-is-deregistered":	"When a Legal Entity to which a power of attorney was granted is deregistered from the Register of Legal Entities",
        "representitive-bankrupt": "When a legal entity to whom a power of attorney was granted is legally declared ’bankrupt’",
        "parent-is-deregistered": "When the power of attorney, which was re-authorised, had expired.",
        'ja-refuse-mandate': 'When the procuracy is revoked by the legal entity which granted it',
        'procurator-refuse-mandate': 'Prokuristui atsisakius prokūros',
        'court-procurator-missing': 'Teismo sprendimu prokuristą pripažinus nežinia kur esančiu',
        'end-of-mandate': 'Teismo sprendimu pripažinus įgaliojimą negaliojančiu',
        'end-of-procuracy': 'Teismo sprendimu pripažinus prokūrą negaliojančia',
        'suspended-mandate': 'Įgaliojimas sustabdytas',
        'suspended-procuracy': 'Prokūra sustabdyta',
        'cancel-suspension-mandate': 'Įgaliojimo sustabdymas panaikintas',
        'cancel-suspension-procuracy': 'Prokūros sustabdymas panaikintas',
      }
    },

    'dataProviderType': {
      "lt": {
        "person-fiz": "Savitarnos naudotojas (fizinis asmuo)",
        "person-jur": "Savitarnos naudotojas (juridinis asmuo)",
        "system-gr": "Automatinis procesas GR",
        "system-nir": "Automatinis procesas NIRVAR",
        "system-jar": "Automatinis procesas JAR",
        "system": "Automatinis procesas (įgaliojimo termino pabaiga)",
        "notary": "Notaras",
        "court": "Teismas",
        "prison": "Bausmių vykdymo sistemos pareigūnas",
        "consul": "Konsulinis pareigūnas",
        "rc_registrator": "RC Registratorius",
      },
      "en": {
        "person-fiz": "Savitarnos naudotojas (Natural person)",
        "person-jur": "Savitarnos naudotojas (Legal entity)",
        "system-gr": "Automatinis procesas GR",
        "system-nir": "Automatinis procesas NIRVAR",
        "system-jar": "Automatinis procesas JAR",
        "system": "Automatinis procesas (įgaliojimo termino pabaiga)",
        "notary": "Notaras",
        "court": "Teismas",
        "prison": "Bausmių vykdymo sistemos pareigūnas",
        "consul": "Konsulinis pareigūnas",
        "rc_registrator": "RC Registratorius",
      }
    },

    "sendMode": {
      "lt": {
        "307": "Per ĮREG",
        "308": "Per Savitarną",
      },
      "en": {
        "307": "Per ĮREG",
        "308": "Per Savitarną",
      }
    },

    "receiveMode": {
      "lt": {
        "307": "Per ĮREG",
        "308": "Per savitarną",
        "305": "VIISP / iPasas",
        "303": "Per įgaliotą asmenį",
        "301": "Elektroniniu",
        "302": "Paštu",
        "304": "Faksu",
        // "306": "Asmeniškai",
      },
      "en": {
        "307": "Per ĮREG",
        "308": "Per savitarną",
        "305": "VIISP / iPasas",
        "303": "Per įgaliotą asmenį",
        "301": "Elektroniniu",
        "302": "Paštu",
        "304": "Faksu",
        // "306": "Asmeniškai",
      }
    },

    "receiveModePredefinedOrder": [
      '307', '308', '305', '303', '301', '302', '304',
    ],

    "sentMode": {
      "lt": {
        "ireg": "ĮREG",
        "sms": "SMS",
        "email": "El. paštu",
        "301": 'Elektroniniu būdu',
        "302": 'Paštu',
        "303": 'Per įgaliotą asmenį',
        "304": 'Faksu',
        "305": 'Per VIISP / iPasas',
      },
      "en": {
        "ireg": "ĮREG",
        "sms": "SMS",
        "email": "By email",
        "301": 'Electronically',
        "302": 'By post',
        "303": 'Through an authorized person',
        "304": 'By fax',
        "305": 'Via VIISP / iPasas',
      }
    },

    "dataVolumeOrderIregArchive": {
      "lt": {
        "01": "Išsami informacija",
        "02": "Išsami informacija su turiniu",
        "03": "Santrauka",
        "04": "Archyvas",
        "05": "Archyvas su turiniu",
        "06": "Broker vidinis",
      },
      "en": {
        "01": "Detailed information",
        "02": "Detailed information with content",
        "03": "Summary",
        "04": "Archive",
        "05": "Archive with content",
        "06": "Broker internal"
      }
    },

    "dataVolumeOrderIreg": {
      "lt": {
        "01": "Išsami informacija",
        "02": "Išsami informacija su turiniu",
        "03": "Santrauka",
        "04": "Archyvas",
        "05": "Archyvas su turiniu",
      },
      "en": {
        "01": "Detailed information",
        "02": "Detailed information with content",
        "03": "Summary",
        "04": "Archive",
        "05": "Archive with content",
      }
    },
    "dataVolumeOrderSav": {
      "lt": {
        "01": "Išsami informacija",
        "02": "Išsami informacija su turiniu",
        "03": "Santrauka",
      },
      "en": {
        "01": "Detailed information",
        "02": "Detailed information with content",
        "03": "Summary",
      }
    },

    "withdrawalOrder": {
      "lt": {
        "01": "El. dokumentas RC Savitarnoje",
        "02": "Atsiimti bet kuriame RC padalinyje",
        "03": "El. dokumentas",
      },
      "en": {
        "01": "E-document in RC Self-service",
        "02": "Pick up at any RC location",
        "03": "E-document",
      }
    },

    "withdrawalOrderSav": {
      "lt": {
        "01": "El. dokumentas RC Savitarnoje",
        "02": "Atsiimti bet kuriame RC padalinyje",
      },
      "en": {
        "01": "E-document in RC Self-service",
        "02": "Pick up at any RC location",
      }
    },

    "withdrawalOrderPublic": {
      "lt": {
        // "01": "El. dokumentas RC Savitarnoje",
        "02": "Atsiimti bet kuriame RC padalinyje",
      },
      "en": {
        // "01": "E-document in RC Self-service",
        "02": "Pick up at any RC location",
      }
    },

    "cartStatus": {
      "lt": {
        "-4": "Panaikintas",
        "-2": "Atsauktas",
        "0": "Kuriamas",
        "2": "Laukia apmokėjimo",
        "4": "Apmokėtas"
      },
      "en": {
        "-4": "Revoked",
        "-2": "Withdrawn",
        "0": "Under creation",
        "2": "Awaiting payment",
        "4": "Paid"
      }
    },

    "searchSource": {
      "lt": {
        "self-service": "Savitarna",
        "public-service": "Vieša paieška",
        "ireg": "IREG",
      },
      "en": {
        "self-service": "Self-service",
        "public-service": "Public search",
        "ireg": "IREG",
      }
    },

    "searchOrderStatusList": {
      "lt": {
        "ordered": "Užsakytas",
        "waiting-for-payment": "Laukia apmokėjimo",
        "payed": "Apmokėta ir vykdoma",
        "provided": "Patvirtintas",
        "rejected": "Atmestas",
        "done": "Išduotas"
      },
      "en": {
        "ordered": "Ordered",
        "waiting-for-payment": "Awaiting payment",
        "payed": "Paid and in progress",
        "provided": "Approved",
        "rejected": "Rejected",
        "done": "Issued"
      }
    },

    "searchOrderStatus": {
      "lt": {
        "ordered": "Užsakytas",
        "payed": "Apmokėta ir vykdoma",
        "provided": "Patvirtintas",
        "rejected": "Atmestas",
        "done": "Išduotas"
      },
      "en": {
        "ordered": "Ordered",
        "payed": "Paid and in progress",
        "provided": "Approved",
        "rejected": "Rejected",
        "done": "Issued"
      }
    },

    "searchListStatus": {
      "lt": {
        "filling": "Vykdoma",
        "rejected": "Neįvykdyta",
        "done": "Įvykdyta",
      },
      "en": {
        "filling": "In progress",
        "rejected": "Not fulfilled",
        "done": "Completed",
      }
    },

    "userRoles": {
      "lt": {
        "representitive": "Įgaliotinis",
        "sub_representitive": "Perįgaliotinis",
        "data-provider": "Duomenų teikėjas",
        "principal": "Įgaliotojas",
      },
      "en": {
        "representitive": "Representitive",
        "sub_representitive": "Sub-delegate",
        "data-provider": "Data provider",
        "principal": "Principal",
      }
    },

    "msgSendTypes": {
      "lt": {
        "ireg": "ĮREG pranešimai",
        "sms": "ĮREG pranešimai SMS",
        "email": "ĮREG pranešimai El. paštu",
        "301": 'Elektroniniu būdu',
        "302": 'Paštu',
        "303": 'Per įgaliotą asmenį',
        "304": 'Faksu',
        "305": 'Per VIISP / iPasas',
      },
      "en": {
        "ireg": "ĮREG pranešimai",
        "sms": "ĮREG pranešimai SMS",
        "email": "ĮREG pranešimai El. paštu",
        "301": 'Electronically',
        "302": 'By post',
        "303": 'Through an authorized person',
        "304": 'By fax',
        "305": 'Via VIISP / iPasas',
      }
    },

    "msgStatusTypes": {
      "lt": {
        "01": "Įvykdytas",
        "02": "Neišsiųstas",
      },
      "en": {
        "01": "Sent",
        "02": "Not sent",
      }
    },

    "StatementStatus": {
      "lt": {
        "filling": "Rengiamas",
        "waiting-for-payment": "Laukia apmokėjimo",
        "payed": "Apmokėta ir vykdoma",
        "provided": "Patvirtintas",
        "rejected": "Atmesta",
        "done": "Išduotas",
      },
      "en": {
        "filling": "Under preparation",
        "waiting-for-payment": "Awaiting payment",
        "payed": "Paid and in progress",
        "provided": "Approved",
        "rejected": "Rejected",
        "done": "Issued",
      }
    },

    "StatementSearchType": {
      "lt": {
        "FIZ": 'Fizinis asmuo',
        "JUR": 'Juridinis asmuo',
        "other-criteria": 'Kiti kriterijai',
      },
      "en": {
        "FIZ": 'Natural person',
        "JUR": 'Legal entity',
        "other-criteria": 'Kiti kriterijai',
      }
    },
    "brockerActionTypes" : {
      "lt": {
        '6849': 'Išsami informacija pagal fizinio asmens kodą arba ILTU kodą ir notarinio registro numerį',
        '6850': 'Išsami informacija pagal fizinio asmens gimimo datą, vardą, pavardę ir notarinio registro numerį',
        '6851': 'Išsami informacija pagal juridinio asmens kodą ir notarinio registro numerį',
        '6852': 'Išsami informacija pagal juridinio asmens kodą, valstybę ir notarinio registro numerį',
        '6853': 'Išsami informacija pagal informacinių technologijų priemonėmis sudaryto įgaliojimo identifikavimo kodą ir fizinio asmens kodą arba ILTU kodą',
        '6854': 'Išsami informacija pagal informacinių technologijų priemonėmis sudaryto įgaliojimo identifikavimo kodą ir juridinio asmens kodą',
        '6855': 'Išsami informacija pagal fizinio asmens kodą arba ILTU kodą ir vardą, pavardę',
        '6856': 'Išsami informacija pagal fizinio asmens gimimo datą ir vardą, pavardę',
        '6857': 'Išsami informacija pagal juridinio asmens kodą',
        '6858': 'Išsami informacija pagal juridinio asmens kodą ir valstybę',
        '6859': 'Išsami informacija pagal fizinio asmens kodą arba ILTU kodą ir notarinio registro numerį su įgaliojimo turiniu',
        '6860': 'Išsami informacija pagal fizinio asmens gimimo datą, vardą, pavardę ir notarinio registro numerį su įgaliojimo turiniu',
        '6861': 'Išsami informacija pagal juridinio asmens kodą ir notarinio registro numerį su įgaliojimo turiniu',
        '6862': 'Išsami informacija pagal juridinio asmens kodą, valstybę ir notarinio registro numerį su įgaliojimo turiniu',
        '6863': 'Išsami informacija pagal fizinio asmens kodą arba ILTU kodą ir vardą, pavardę su įgaliojimo turiniu',
        '6864': 'Išsami informacija pagal fizinio asmens gimimo datą ir vardą, pavardę su įgaliojimo turiniu',
        '6865': 'Išsami informacija pagal juridinio asmens kodą su įgaliojimo turiniu',
        '6866': 'Išsami informacija pagal juridinio asmens kodą ir valstybę su įgaliojimo turiniu',
        '6867': 'Dokumentų santrauka pagal fizinio asmens kodą arba ILTU kodą ir notarinio registro numerį',
        '6868': 'Dokumentų santrauka pagal fizinio asmens gimimo datą, vardą, pavardę ir notarinio registro numerį',
        '6869': 'Dokumentų santrauka pagal juridinio asmens kodą ir notarinio registro numerį',
        '6870': 'Dokumentų santrauka pagal juridinio asmens kodą, valstybę ir notarinio registro numerį',
        '6871': 'Dokumentų santrauka pagal informacinių technologijų priemonėmis sudaryto įgaliojimo identifikavimo kodą ir fizinio asmens kodą arba ILTU kodą',
        '6872': 'Dokumentų santrauka pagal informacinių technologijų priemonėmis sudaryto įgaliojimo identifikavimo kodą ir juridinio asmens kodą',
        '6873': 'Dokumentų santrauka pagal fizinio asmens kodą arba ILTU kodą ir vardą, pavardę',
        '6874': 'Dokumentų santrauka pagal fizinio asmens gimimo datą ir vardą, pavardę',
        '6875': 'Dokumentų santrauka pagal juridinio asmens kodą',
        '6876': 'Dokumentų santrauka pagal juridinio asmens kodą ir valstybę',
        '6877': 'ĮR archyvo išrašas pagal fizinio asmens kodą arba ILTU kodą ir notarinio registro numerį',
        '6878': 'ĮR archyvo išrašas pagal fizinio asmens gimimo datą, vardą, pavardę ir notarinio registro numerį',
        '6879': 'ĮR archyvo išrašas pagal juridinio asmens kodą ir notarinio registro numerį',
        '6880': 'ĮR archyvo išrašas pagal juridinio asmens kodą, valstybę ir notarinio registro numerį',
        '6881': 'ĮR archyvo išrašas pagal informacinių technologijų priemonėmis sudaryto įgaliojimo identifikavimo kodą ir fizinio asmens kodą arba ILTU kodą',
        '6882': 'ĮR archyvo išrašas pagal informacinių technologijų priemonėmis sudaryto įgaliojimo identifikavimo kodą ir juridinio asmens kodą',
        '6883': 'ĮR archyvo išrašas pagal fizinio asmens kodą arba ILTU kodą ir vardą, pavardę',
        '6884': 'ĮR archyvo išrašas pagal fizinio asmens gimimo datą ir vardą, pavardę',
        '6885': 'ĮR archyvo išrašas pagal juridinio asmens kodą',
        '6886': 'ĮR archyvo išrašas pagal juridinio asmens kodą ir valstybę',
        '6887': 'ĮR archyvo išrašas pagal fizinio asmens kodą arba ILTU kodą ir notarinio registro numerį su įgaliojimo turiniu',
        '6888': 'ĮR archyvo išrašas pagal fizinio asmens gimimo datą, vardą, pavardę ir notarinio registro numerį su įgaliojimo turiniu',
        '6889': 'ĮR archyvo išrašas pagal juridinio asmens kodą ir notarinio registro numerį su įgaliojimo turiniu',
        '6890': 'ĮR archyvo išrašas pagal juridinio asmens kodą, valstybę ir notarinio registro numerį su įgaliojimo turiniu',
        '6891': 'ĮR archyvo išrašas pagal fizinio asmens kodą arba ILTU kodą ir vardą, pavardę su įgaliojimo turiniu',
        '6892': 'ĮR archyvo išrašas pagal fizinio asmens gimimo datą ir vardą, pavardę su įgaliojimo turiniu',
        '6893': 'ĮR archyvo išrašas pagal juridinio asmens kodą su įgaliojimo turiniu',
        '6894': 'ĮR archyvo išrašas pagal juridinio asmens kodą ir valstybę su įgaliojimo turiniu',
        '6895': 'Išsami informacija pagal įgaliotinio juridinio arba fizinio asmens kodą arba ILTU kodą, paslaugos kodą ir paslaugos teikėjo juridinio arba fizinio asmens kodą arba ILTU kodą',
        '0000': "(TIK VIDINIAM NAUDOJIMUI) dokumentų santrauka pagal įgaliotinio juridinio arba fizinio asmens kodą arba ILTU kodą, paslaugos kodą ir paslaugos teikėjo juridinio arba fizinio asmens kodą arba ILTU kodą",
        '6896': 'Dokumentų santrauka pagal įgaliotinio juridinio arba fizinio asmens kodą arba ILTU kodą, paslaugos kodą ir paslaugos teikėjo juridinio arba fizinio asmens kodą arba ILTU kodą',
        '6897': 'išsami informacija pagal įgaliotojo ar įgaliotinio fizinio asmens gimimo datą, vardą, pavardę ir informacinių technologijų priemonėmis sudaryto įgaliojimo identifikavimo kodą',
        '6898': 'Dokumentų santrauka pagal įgaliotojo ar įgaliotinio fizinio asmens gimimo datą, vardą, pavardę ir informacinių technologijų priemonėmis sudaryto įgaliojimo identifikavimo kodą',
        '6899': 'ĮR archyvo išrašas pagal įgaliotojo ar įgaliotinio fizinio asmens fizinio asmens gimimo datą, vardą, pavardę ir informacinių technologijų priemonėmis sudaryto įgaliojimo identifikavimo kodą',
        '6900': 'Išsami informacija pagal įgaliotinio fizinio asmens gimimo datą ir vardą, pavardę ar įgaliotinio juridinio asmens kodą ir paslaugos kodą, ir paslaugos teikėjo fizinio asmens gimimo datą ir vardą, pavardę ar paslaugos teikėjo juridinio asmens kodą',
        '6901': 'Dokumentų santrauka pagal įgaliotinio fizinio asmens gimimo datą ir vardą, pavardę ar įgaliotinio juridinio asmens kodą ir paslaugos kodą, ir paslaugos teikėjo fizinio asmens gimimo datą ir vardą, pavardę ar paslaugos teikėjo juridinio asmens kodą',
        '6902': 'ĮR archyvo išrašas pagal įgaliotinio fizinio asmens gimimo datą ir vardą, pavardę ar įgaliotinio juridinio asmens kodą ir paslaugos kodą, ir paslaugos teikėjo fizinio asmens gimimo datą ir vardą, pavardę ar paslaugos teikėjo juridinio asmens kodą',
        '5512': '(TIK VIDINIAM NAUDOJIMUI) išsami informacija ir ĮR archyvo išrašas su turiniu pagal identifikavimo kodą, fizinio asmens kodą arba ILTU kodą, gimimo datą, AMN_ID, paslaugų teikėją, juridinio asmens kodą, vardą, pavardę, valstybę, notarinio registro numerį, paslaugos / veiksmo kodą, periodą.',
        '5531': 'Išsami informacija pagal prokuristo asmens kodą arba ILTU kodą ir vardą, pavardę su prokūros turiniu',
        '5532': 'Išsami informacija pagal prokuristo gimimo datą ir vardą, pavardę su prokūros turiniu',
        '5533': 'Išsami informacija pagal juridinio asmens kodą su prokūros turiniu',
        '5534': 'Išsami informacija pagal prokuristo asmens kodą arba ILTU kodą ir prokūros identifikavimo kodą registre',
        '5535': 'Išsami informacija pagal prokuristo asmens kodą arba ILTU kodą ir prokūros identifikavimo kodą registre su prokūros turiniu',
        '5536': 'Išsami informacija pagal prokuristo gimimo datą ir vardą, pavardę ir prokūros identifikavimo kodą registre',
        '5537': 'Išsami informacija pagal prokuristo gimimo datą ir vardą, pavardę ir prokūros identifikavimo kodą registre su prokūros turiniu',
        '5538': 'Išsami informacija pagal juridinio asmens kodą ir prokūros identifikavimo kodą registre',
        '5539': 'Išsami informacija pagal juridinio asmens kodą ir prokūros identifikavimo kodą registre su prokūros turiniu',
        '5540': 'ĮR archyvo išrašas pagal prokuristo asmens kodą arba ILTU kodą ir vardą, pavardę su prokūros turiniu',
        '5541': 'ĮR archyvo išrašas pagal prokuristo gimimo datą ir vardą, pavardę su prokūros turiniu',
        '5542': 'ĮR archyvo išrašas pagal juridinio asmens kodą su prokūros turiniu',
        '5543': 'ĮR archyvo išrašas pagal prokuristo asmens kodą arba ILTU kodą ir prokūros identifikavimo kodą registre',
        '5544': 'ĮR archyvo išrašas pagal prokuristo asmens kodą arba ILTU kodą ir prokūros identifikavimo kodą registre su prokūros turiniu',
        '5545': 'ĮR archyvo išrašas pagal prokuristo gimimo datą ir vardą, pavardę ir prokūros identifikavimo kodą registre',
        '5546': 'ĮR archyvo išrašas pagal prokuristo gimimo datą ir vardą, pavardę ir prokūros identifikavimo kodą registre su prokūros turiniu',
        '5547': 'ĮR archyvo išrašas pagal juridinio asmens kodą ir prokūros identifikavimo kodą registre',
        '5548': 'ĮR archyvo išrašas pagal juridinio asmens kodą ir prokūros identifikavimo kodą registre su prokūros turiniu',
        '5549': 'Įgaliojimų registro paslaugų klasifikatoriaus duomenų paėmimas',
        '5550': 'Įgaliojimų registro paslaugų klasifikatoriaus duomenų teikimas',
        '5501': '(TIK VIDINIAM NAUDOJIMUI) ĮR dokumentų santrauka pagal įgaliotinio JA arba FA kodą arba ILTU kodą, paslaugos kodą ir paslaugos teikėjo JA arba FA kodą arba ILTU kodą',
        '5509': 'ĮR dokumentų santrauka pagal juridinio asmens kodą arba fizinio asmens kodą, arba ILTU kodą ir IS identifikatorių',
      },
      "en": {}
    },
    "ActionTypes" : {
      "lt": {
        'person-search': 'Asmens paieška',
        "agree-with-security-notification": 'Sutiko su saugos dokumentais',
        "object-state-changed": 'Pasikeitė objekto būsena',
        "broker-on": 'Įjungė Broker',
        "broker-off": 'Išjungė Broker',
        "check-iltu-on": 'Įjungė ILTU kodo gavimą',
        "check-iltu-off": 'Išjungė ILTU kodo gavimą',
        "nirvar-on": 'Įjungė NIRVAR',
        "nirvar-off": 'Išjungė NIRVAR',
        "agree-terms": 'Patvirtino el. paslaugos naudojimo sutarties sąlygas',
        "statement-search": "Atliko išrašo paiešką"
      },
      "en": {
        'person-search': 'Asmens paieška',
        "agree-with-security-notification": 'Sutiko su saugos dokumentais',
        "object-state-changed": 'Pasikeitė objekto būsena',
        "broker-on": 'Įjungė Broker',
        "broker-off": 'Išjungė Broker',
        "check-iltu-on": 'Įjungė ILTU kodo gavimą',
        "check-iltu-off": 'Išjungė ILTU kodo gavimą',
        "nirvar-on": 'Įjungė NIRVAR',
        "nirvar-off": 'Išjungė NIRVAR',
        "agree-terms": 'Patvirtino el. paslaugos naudojimo sutarties sąlygas',
        "statement-search": "Atliko išrašo paiešką"
      }
    },

    "StatementActionType": {
    // Role IR_issami
      '6795' : 'Issami_FizAKarILTU_Notarini',
      '6796' : 'Issami_FizGimData_Vardas_Pavarde_Notarini',
      '6797' : 'Issami_JurKodas_Notarini',
      '6798' : 'Issami_JurKodas_Valstybe_Notarini',
      '6799' : 'Issami_ItpsiKoda_FizAKarILTU',
      '6800' : 'Issami_ItpsiKoda_JurKodas',
      '6843' : 'Issami_FizGimData_Vardas_Pavarde_ItpsiKoda',
    // Role IR_kitos
      '6801' : 'Issami_FizAKarILTU_Vardas_Pavarde',
      '6802' : 'Issami_FizGimData_Vardas_Pavarde',
      '6803' : 'Issami_JurKodas',
      '6804' : 'Issami_JurKodas_Valstybe',
      '6809' : 'IssamiTuriniu_FizAKarILTU_Vardas_Pavarde',
      '6810' : 'IssamiTuriniu_FizGimData_Vardas_Pavarde',
      '6811' : 'IssamiTuriniu_JurKodas',
      '6812' : 'IssamiTuriniu_JurKodas_Valstybe',
      '6819' : 'Santrauka_FizAKarILTU_Vardas_Pavarde',
      '6820' : 'Santrauka_FizGimData_Vardas_Pavarde',
      '6821' : 'Santrauka_JurKodas',
      '6822' : 'Santrauka_JurKodas_Valstybe',
    // Role IR_issami_su_turiniu
      '6805' : 'IssamiTuriniu_FizAKarILTU_Notarini',
      '6806' : 'IssamiTuriniu_FizGimData_Vardas_Pavarde_Notarini',
      '6807' : 'IssamiTuriniu_JurKodas_Notarini',
      '6808' : 'IssamiTuriniu_JurKodas_Valstybe_Notarini',
    //Role IR_santrauka
      '6813' : 'Santrauka_FizAKarILTU_Notarini',
      '6814' : 'Santrauka_FizGimData_Vardas_Pavarde_Notarini',
      '6815' : 'Santrauka_JurKodas_Notarini',
      '6816' : 'Santrauka_JurKodas_Valstybe_Notarini',
      '6817' : 'Santrauka_ItpsiKoda_FizAKarILTU',
      '6818' : 'Santrauka_ItpsiKoda_JurKodas',
      '6844' : 'Santrauka_FizGimData_Vardas_Pavarde_ItpsiKoda',
    // Role IR_archyvas
      '6823' : 'Archyvas_FizAKarILTU_Notarini',
      '6824' : 'Archyvas_FizGimData_Vardas_Pavarde_Notarini',
      '6825' : 'Archyvas_JurKodas_Notarini',
      '6826' : 'Archyvas_JurKodas_Valstybe_Notarini',
      '6827' : 'Archyvas_ItpsiKoda_FizAKarILTU',
      '6828' : 'Archyvas_ItpsiKoda_JurKodas',
      '6833' : 'ArchyvasTuriniu_FizAKarILTU_Notarini',
      '6834' : 'ArchyvasTuriniu_FizGimData_Vardas_Pavarde_Notarini',
      '6835' : 'ArchyvasTuriniu_JurKodas_Notarini',
      '6836' : 'ArchyvasTuriniu_JurKodas_Valstybe_Notarini',
      '6845' : 'Archyvas_FizGimData_Vardas_Pavarde_ItpsiKoda',
      '6848' : 'Archyvas_FizGimData_Vardas_Pavarde_PaslaugosKodas_TeikejoFizGimDataVardasPavardeArJurKoda',
    // Role IR_archyvas_kitos
      '6829' : 'Archyvas_FizAKarILTU_Vardas_Pavarde',
      '6830' : 'Archyvas_FizGimData_Vardas_Pavarde',
      '6831' : 'Archyvas_JurKodas',
      '6832' : 'Archyvas_JurKodas_Valstybe',
      '6837' : 'ArchyvasTuriniu_FizAKarILTU_Vardas_Pavarde',
      '6838' : 'ArchyvasTuriniu_FizGimData_Vardas_Pavarde',
      '6839' : 'ArchyvasTuriniu_JurKodas',
      '6840' : 'ArchyvasTuriniu_JurKodas_Valstybe',
    // Role IR_RC_darbuotojas
      'NULL' : 'Vidinis',
    // Role IR_paslauga
      '6841' : 'Issami_IgaliotinioAKarILTUarJurKoda_PaslaugosKodas_TeikejoKodas',
      '6842' : 'Santrauka_IgaliotionioAKarILTUarJurKoda_PaslaugosKodas_TeikejoKodas',
      '6846' : 'Issami_FizGimData_Vardas_Pavarde_PaslaugosKodas_TeikejoFizGimDataVardasPavardeArJurKoda',
      '6847' : 'Santrauka_FizGimData_Vardas_Pavarde_PaslaugosKodas_TeikejoFizGimDataVardasPavardeArJurKoda',
    // PROKŪRA
      '5513' : 'Issami_ProkuristoAKarILTU_Vardas_Pavarde_Turiniu',
      '5514' : 'Issami_ProkuristoGimData_Vardas_Pavarde_Turiniu',
      '5515' : 'Issami_JurKodas_Turiniu',
      '5516' : 'Issami_ProkuristoAKarILTU_PPKoda',
      '5517' : 'Issami_ProkuristoAKarILTU_PPKoda_Turiniu',
      '5518' : 'Issami_ProkuristoGimData_Vardas_Pavarde_PPKoda',
      '5519' : 'Issami_ProkuristoGimData_Vardas_Pavarde_PPKoda_Turiniu',
      '5520' : 'Issami_JurKodas_PPKoda',
      '5521' : 'Issami_JurKodas_PPKoda_Turiniu',
      '5522' : 'Archyvas_ProkuristoAKarILTU_Vardas_Pavarde_Turiniu',
      '5523' : 'Archyvas_ProkuristoGimData_Vardas_Pavarde_Turiniu',
      '5524' : 'Archyvas_JurKodas_Turiniu',
      '5525' : 'Archyvas_ProkuristoAKarILTU_PPKoda',
      '5526' : 'Archyvas_ProkuristoAKarILTU_PPKoda_Turiniu',
      '5527' : 'Archyvas_ProkuristoGimData_Vardas_Pavarde_PPKoda',
      '5528' : 'Archyvas_ProkuristoGimData_Vardas_Pavarde_PPKoda_Turiniu',
      '5529' : 'Archyvas_JurKodas_PPKoda',
      '5530' : 'Archyvas_JurKodas_PPKoda_Turiniu',
    },

    "providerType":{
      'unidentified-physical': 'Bet kuris fizinis asmuo',
      'unidentified-juridical': 'Bet kuris juridinis asmuo',
      'unidentified-physical-juridical' : 'Bet kuris fizinis arba juridinis asmuo',
      'amn': 'Ieškoti paslaugų teikėjo',
    },

    "providerTypeTran":{
      "lt": {
        'unidentified-physical': 'Bet kuris fizinis asmuo',
        'unidentified-juridical': 'Bet kuris juridinis asmuo',
        'unidentified-physical-juridical' : 'Bet kuris fizinis arba juridinis asmuo',
        'amn': 'Ieškoti paslaugų teikėjo',
      },
      "en": {
        'unidentified-physical': 'Bet kuris fizinis asmuo',
        'unidentified-juridical': 'Bet kuris juridinis asmuo',
        'unidentified-physical-juridical' : 'Bet kuris fizinis arba juridinis asmuo',
        'amn': 'Ieškoti paslaugų teikėjo',
      }
    },

    "procurationKind":{
      "lt": {
        'general': 'Bendroji',
        'sole': 'Vienasmenė',
      },
      "en": {
        'general': 'General',
        'sole': 'Sole',
      }
    },

    "docLanguage":{
      "lt": {
        'lt': 'lietuvių kalba',
        'en': 'anglų kalba',
      },
      "en": {
        'lt': 'Lithuanian',
        'en': 'English',
      }

    },

    "bilingualMandate":{
      "lt": {
        '0': 'Lietuvių kalba',
        '1': 'Lietuvių ir anglų kalbomis',
      },
      "en": {
        '0': 'Lithuanian',
        '1': 'Lithuanian and English',
      }

    },

    "rejectReasonType":{
      "lt": {
        'ntpi': 'NTPĮ',
        'itpsi': 'El. įgaliojimai',
        'pp': 'Prokūros',
        'statement': 'Išrašas',
        'invalid-representers': 'Netinkami atstovai',
      },
      "en": {
        'ntpi': 'NTPĮ',
        'itpsi': 'El. įgaliojimai',
        'pp': 'Prokūros',
        'statement': 'Išrašas',
        'invalid-representers': 'Netinkami atstovai',
      },

    },

    "test":{
      "lt": {
        '01': '01',
        '02': '02',
        '03': '03',
      },
      "en": {
        '01': '01',
        '02': '02',
        '03': '03',
      },
    },

    "msgType":{
      "lt": {
        "[401]": "Pranešimas Įgaliojimų registrui apie įgaliojimo patvirtinimą",
        "[402]": "Pranešimas Įgaliojimų registrui apie įgaliojimo pakeitimą",
        "[424]": "Pranešimas Įgaliojimų registrui apie įgaliojimo pasibaigimą",
        "[424,425]": 'Pranešimas Įgaliojimų registrui apie įgaliojimo / prokūros pasibaigimą',
        "[426,427]": 'Pranešimas Įgaliojimų registrui apie įgaliojimo / prokūros galiojimo sustabdymą',
        "[428,429]": 'Pranešimas Įgaliojimų registrui apie įgaliojimo / prokūros galiojimo sustabdymo panaikinimą',
        "[430,411]": 'Pranešimas Įgaliojimų registrui apie įgaliotojo arba įgaliotinio / prokuristo pripažinimą nežinia kur esančiu',
      },
      "en": {
        "[401]": "Pranešimas Įgaliojimų registrui apie įgaliojimo patvirtinimą",
        "[402]": "Pranešimas Įgaliojimų registrui apie įgaliojimo pakeitimą",
        "[424]": "Pranešimas Įgaliojimų registrui apie įgaliojimo pasibaigimą",
        "[424,425]": 'Pranešimas Įgaliojimų registrui apie įgaliojimo / prokūros pasibaigimą',
        "[426,427]": 'Pranešimas Įgaliojimų registrui apie įgaliojimo / prokūros galiojimo sustabdymą',
        "[428,429]": 'Pranešimas Įgaliojimų registrui apie įgaliojimo / prokūros galiojimo sustabdymo panaikinimą',
        "[430,411]": 'Pranešimas Įgaliojimų registrui apie įgaliotojo arba įgaliotinio / prokuristo pripažinimą nežinia kur esančiu',
      }
    },

    "msgErrorsCorrectionType":{
      "lt": {
        "[403]": "Tarnybinis pranešimas apie registro duomenų netikslumus",
        "[405]": "Tarnybinis pranešimas apie klaidingai įregistruotą objektą",
      },
      "en": {
        "[403]": "Tarnybinis pranešimas apie registro duomenų netikslumus",
        "[405]": "Tarnybinis pranešimas apie klaidingai įregistruotą objektą",
      }
    },

    "requestsType":{
      "lt": {
        "421": "Prokūrą išdavusio JA prašymas dėl prokūros įregistravimo",
        "422": "Prokūrą išdavusio JA prašymas Įgaliojimų registrui dėl prokūros pabaigos",
        "423": "Prokuristo prašymas Įgaliojimų registrui dėl prokūros pabaigos",
      },
      "en": {
        "421": "Prokūrą išdavusio JA prašymas dėl prokūros įregistravimo",
        "422": "Prokūrą išdavusio JA prašymas Įgaliojimų registrui dėl prokūros pabaigos",
        "423": "Prokuristo prašymas Įgaliojimų registrui dėl prokūros pabaigos",
      }
    },

    "requestStatus":{
      "lt": {
        "801": "Rengiamas",
        "802": "Priimtas",
        "803": "Atmestas",
        "807": "Apmokėta ir vykdoma",
        "808": "Įvykdytas",
      },
      "en": {
        "801": "Under preparation",
        "802": "Accepted",
        "803": "Rejected",
        "807": "Paid and in progress",
        "808": "Completed",
      }
    },

    "objectStatus":{
      "lt": {
        "1602": "Įregistruotas",
        "1604": "Išregistruotas",
      },
      "en": {
        "1602": "Registered",
        "1604": "Deregistered",
      }
    },

    "objectType":{
      "lt": {
        "ITPSI": "ITPSĮ",
        "ITPSP": "Prokūra (IT)",
        "NTPI": "NTPĮ",
        "PP": "Prokūra",
      },
      "en": {
        "ITPSI": "ITPSĮ",
        "ITPSP": "Prokūra (IT)",
        "NTPI": "NTPĮ",
        "PP": "Prokūra",
      }
    },
    "objectTypeArchive":{
      "lt": {
        "ITPSI": "ITPSĮ",
        "NTPI": "NTPĮ",
        "PP": "Prokūra",
      },
      "en": {
        "ITPSI": "ITPSĮ",
        "NTPI": "NTPĮ",
        "PP": "Prokūra",
      }
    },
    "reportType":{
      "lt": {
        "detailed":"ĮR detalios ataskaitos",
        "summary":"ĮR suminės ataskaitos",
        "comparative":"ĮR lyginamosios ataskaitos",
      },
      "en": {}
    },
    "reportDetailedSubType":{
      "lt": {
        "1": "GDŽ įrašų ataskaitos",
        "2": "Praleistų registravimo terminų",
        "3": "Įgaliotojų (įgaliotinių, prokuristų) skaičius objekte",
        "4": "Įgaliotojai (įgaliotiniai, prokuristai) užsieniečiai",
        "5": "Duomenų teikimas iš Registro",
        "6": "Automatinių procesų vykdymo",
        "7": "Susipažinimo su saugos pranešimais",
        "8": "Atsisakymo vykdyti",
        "9": "ITPSĮ pagal paslaugos teikėją",
        "10": "Klasifikuota paslauga ir jos teikėjai",
        "11": "Neklasifikuota (naudotojo įrašyta) paslauga ir jos teikėjai",
      },
      "en": {}
    },
    "reportSummarySubType":{
      "lt": {
        "12": "Suminė darbo krūvio",
        "13": "Tų pačių objektų išregistravimai per laikotarpį",
        "14": "ITPSĮ pagal paslaugos teikėją",
        "15": "Klasifikuota paslauga ir jos teikėjai",
        "16": "Neklasifikuota paslauga",
        "17": "Įgaliojimų tipų panaudojimas",
        "18": "Duomenų teikimas iš ĮR (paieškos)",
        "21": "NTPĮ pagal teritoriją",
        "22": "Objektų skaičius datai",
        "23": "Objektų skaičius per laikotarpį",
      },
      "en": {}
    },
    "reportComparativeSubType":{
      "lt": {
        "19": "Įregistruotų objektų skaičius",
        "20": "Darbuotojų darbo krūvio ataskaita"
      },
      "en": {}
    },
    "reportTypeDescription":{
      "lt": {
        "1":"Ataskaitoje rodomi pranešimų metaduomenys (pvz.: teikėjas, pranešimo rūšis, būsena, būsenos pakeitimo data).",
        "2":"Ataskaitoje rodomi pranešimai, kurie nesutvarkyti nustatytu terminu (pvz.: vykdytojas, praleistas terminas dienomis). Ataskaita formuojama, jei nuo pranešimo gavimo datos praėjo daugiau nei 2 d.d.",
        "3":"Ataskaitoje rodomi įgaliotojų, įgaliotinių, kurie registuoti JAR ir GR, skaičius objekte (pvz.: objektas, įgaliotinių skaičius, įgaliotojų skaičius).",
        "4":"Ataskaitoje rodomi įgaliotojų, įgaliotinių, kurie registuoti UR arba neregistruoti JAR ir GR, skaičius objekte (pvz.: objektas, įgaliotinių skaičius, įgaliotojų skaičius).",
        "5":"Ataskaitoje rodomi išrašų užsakymai pagal duomenų gavėją ir aplinką (ĮREG, Vieša, Savitarna), per kurią pateiktas išrašo užsakymas, paieškos kriterijus, išrašo rūšį (išsami informacija, santrauka ir t.t).",
        "6":"Ataskaitoje rodomi sistemos automatu suformuoti pranešimai (pvz.: mirtis, neveiksnumas, įgaliojimo termino pabaiga, JA statuso pasikeitimas JAR).",
        "7":"Ataskaitoje rodomi naudotojo susipažinimas su saugos pranešimais (pvz.: naudotojas, saugos pranešimas, susispažinimo data).",
        "8":"Ataskaitoje rodomi registratoriaus atsisakyti vykdyti pranešimai (pvz.: duomenų teikėjas, pranešimo pavadinimas, atsisakymo vykdyti data, vykdytojas - registratorius).",
        "9":"Ataskaitoje rodomi ITPSĮ objekto ID, paslaugos teikėjo FA, JA duomenys, įgaliojimo rūšis (įgaliojimas, perįgaliojimas).",
        "10":"Ataskaitoje rodomi ITPSĮ, kuriuose pasirinktos paslaugos iš klasifikatoriaus \"Veiksmai ir paslaugos\" (pvz.: objektas, paslaugos RC kodas, PASIS kodas, paslaugos pavadinimas, paslaugos teikėjas).",
        "11":"Ataskaitoje rodomi ITPSĮ, kuriuose įgaliotojas suvedė paslaugas, kurių nėra klasifikatoriuje \"Veiksmai ir paslaugos\" (pvz.: objektas, paslaugos aprašymas, paslaugos teikėjas)",
        "12":"Ataskaitoje rodomi registratoriaus veiksmai (įregistravimas, požymio įrašymas, išregistravimas, atsisakymas vykdyti).",
        "13":"Ataskaitoje rodomas objektų, kurie buvo įregistruoti ir tie patys išregistruoti per nurodytą laikotarpį, skaičius (pvz.: įregistuoti, išregistruoti, liko įregistruota laikotarpio pabaigoje objekto skaičius).",
        "14":"Ataskaitoje rodomi ITPSĮ skaičius pagal paslaugos teikėjo FA, JA duomenis.",
        "15":"Ataskaitoje rodomi ITPSĮ skaičius, kuriuose pasirinktos paslaugos iš klasifikatoriaus \"Veiksmai ir paslaugos\" (pvz.: objektas, paslaugos RC kodas, PASIS kodas, paslaugos pavadinimas, paslaugos teikėjas).",
        "16":"Ataskaitoje rodomas paslaugų, kurias įgaliotojas suvedė ITPSĮ ir, kurių nėra klasifikatoriuje \"Veiksmai ir paslaugos\", skaičius.",
        "17":"Ataskaitoje rodomas skaičius ITPSĮ tipų per laikotarpį.",
        "18":"Ataskaitoje rodomas suteiktų išrašų skaičius (pvz.: Duomenų gavėjo tipas, išrašo rūšis (santrauka, išsami ir t.t)).",
        "19":"Ataskaitoje rodomas įregistruotų objektų skaičius per laikotarpį (detalizuojama pagal metus ir mėnesius).",
        "20":"Ataskaitoje rodomas registratoriaus veiksmų (įregistravimas, požymio įrašymas, išregistravimas, atsisakymas vykdyti) skaičius per laikotarpį (detalizuojama pagal metus ir mėnesius).",
        "21":"Ataskaitoje rodomi NTPĮ skaičius pagal duomenų teikėjo nurodytą sudarymo vietą",
        "22":"Ataskaitoje rodomas įregistruotų, išregistruotų objektų (ITPSĮ, NTPĮ, Prokūra) skaičius tai dienai",
        "23":"Ataskaitoje rodomas įregistruotų, išregistruotų objektų (ITPSĮ, NTPĮ, Prokūra) skaičius per laikotarpį",
      },
      "en": {}
    },
    "filterStep":{
      "lt": {
        "day": "Diena",
        "week": "Savaitė",
        "month": "Mėnesis",
        "months3": "3 mėn.",
        "half": "6 mėn.",
        "year": "Metai"
      },
      "en": {}
    },
    "filterStepWorkload":{
      "lt": {
        "day": "Diena",
        "week": "Savaitė",
        "month": "Mėnesis",
        "year": "Metai"
      },
      "en": {}
    }
};

export default Enums;








